import { AxiosResponse } from "axios"
import { Deviation } from "../../../Model/Dto/EmploymentEquity/Plan/Deviation"
import { axiosCoreInstance } from "../../AxiosCoreInterceptor"
import { SearchResult } from "../../../Model/Dto/SearchResult";

const route: string = "EmploymentEquity/Deviations";
export const DeviationsService = {

    GetDeviation: (id: number): Promise<AxiosResponse<Deviation.Dto>> => axiosCoreInstance.get(`${route}/${id}`),
    CreateDeviation: (deviation: Deviation.Dto): Promise<AxiosResponse<Deviation.Dto>> => axiosCoreInstance.post(route, deviation),
    UpdateDeviation: (deviation: Deviation.Dto): Promise<AxiosResponse<Deviation.Dto>> => axiosCoreInstance.put(route, deviation),
    DeleteDeviation: (id: number): Promise<AxiosResponse<void>> => axiosCoreInstance.delete(`${route}/${id}`),
    SearchDeviations: (request: Deviation.SearchRequest): Promise<AxiosResponse<SearchResult<Deviation.SearchResultDto>>> => axiosCoreInstance.post(`${route}/Search`, request),
}